import { httpsCallable } from 'firebase/functions'
import { functions } from '@/config/firebase'

/** Admin updates their own account (spec §4.4). Enforced server-side. */

export async function updateOwnEmail(email: string): Promise<void> {
  await httpsCallable(functions, 'updateOwnEmail')({ email })
}

export async function updateOwnPassword(password: string): Promise<void> {
  await httpsCallable(functions, 'updateOwnPassword')({ password })
}
